import { Component, Input, Output, ViewChild, EventEmitter } from '@angular/core';
import { FileUpload } from 'primeng/fileupload';
import { FileService } from 'src/app/services/file/file.service';
import { WorkBook, WorkSheet } from 'xlsx';

type parsedDefault = { branchCode: string; quantity: number };
type parsedDataWithdate = {
  branchCode: string;
  quantity: number;
  deliveryAt: Date;
};

@Component({
  selector: 'distribution-importfile',
  templateUrl: './distribution-importfile.component.html',
  styleUrls: ['./distribution-importfile.component.scss'],
})
export class DistributionImportfileComponent {
  @Input()
  titleDownloadFile: string = '';

  @Input()
  filePathToDownload: string = '';

  @Input()
  isDownload = false;

  @Input()
  isConfirmed = false;

  @Input()
  isLoading = false;

  @Input()
  directDistribution: boolean = false;

  @Output() parsedData = new EventEmitter<(parsedDefault | parsedDataWithdate)[]>();

  @ViewChild('inputFile')
  inputFile: FileUpload | null = null;

  download(): void {
    window.location.href = this.filePathToDownload;
  }

  onImportFile(event: any): void {
    this.inputFile?.clear();

    if (event.files.length === 0) return;

    FileService.load(event.files[0], 'array').then((data: any): any => {
      import('xlsx').then(xlsx => {
        const workbook: WorkBook = xlsx.read(new Uint8Array(data), { type: 'array' });
        const sheetName: string = workbook.SheetNames[0];
        const worksheet: WorkSheet = workbook.Sheets[sheetName];
        const jsonData = xlsx.utils.sheet_to_json(worksheet, { header: 1 });

        const parsed: any[] = [];
        jsonData.forEach((row: any, index: number): void => {
          if (index === 0) return;

          const expectedLength = this.directDistribution ? 3 : 2;
          if (row.length < expectedLength) return;

          let branchCode: string = row[0].toString();
          let quantity: number = this.isDownload ? parseInt(row[1], 10) : 1;
          let deliveryAt: Date | undefined = this.directDistribution ? new Date(row[2]) : undefined;

          while (branchCode.length < 4) branchCode = '0' + branchCode;

          if (this.directDistribution) {
            parsed.push({ branchCode, quantity, deliveryAt } as parsedDataWithdate);
          } else {
            parsed.push({ branchCode, quantity } as parsedDefault);
          }
        });
        this.parsedData.emit(parsed);
      });
    });
  }
}
